import * as types from 'store/modules/contact/mutation-types'
import contact from 'api/contact'
import swal from 'sweetalert'

export default {
  state: {
    contacts: [],
    fullname: {
      total: 0,
      rows: [{
        codempid: '',
        descCodempid: ''
      }]
    },
    company: {
      total: 0,
      rows: [{
        codcomp: '',
        descCodcomp: ''
      }]
    },
    position: {
      total: 0,
      rows: [{
        codpos: '',
        descCodpos: ''
      }]
    }
  },
  getters: {
    [types.GET_FULLNAME] (state) {
      return state.fullname
    },
    [types.GET_COMPANY] (state) {
      return state.company
    },
    [types.GET_POSITION] (state) {
      return state.position
    }
  },
  mutations: {
    [types.SET_FULLNAME] (state, fullname) {
      state.fullname = fullname
    },
    [types.SET_COMPANY] (state, company) {
      state.company = company
    },
    [types.SET_POSITION] (state, position) {
      state.position = position
    }
  },
  actions: {
    [types.RECEIVED_CONTACTS_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      contact.receivedContactsInfiniteLoading(params.searchParams)
        .then((response) => {
          triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve contact again', message)
          contact.receivedContactsInfiniteLoading(params.searchParams)
            .then((response) => {
              triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.RECEIVED_FULLNAMES] ({ commit }) {
      contact.receivedFullnames()
        .then((response) => {
          const fullnameObj = JSON.parse(response.request.response)
          commit(types.SET_FULLNAME, fullnameObj)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_COMPANIES] ({ commit }) {
      contact.receivedCompanies()
        .then((response) => {
          const companyObj = JSON.parse(response.request.response)
          commit(types.SET_COMPANY, companyObj)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_POSITIONS] ({ commit }) {
      contact.receivedPositions()
        .then((response) => {
          const positionObj = JSON.parse(response.request.response)
          commit(types.SET_POSITION, positionObj)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_CONTACT_FAVORITE] ({ commit }, postParams) {
      contact.postContactFavorite(postParams)
        .then((response) => {
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/index.js